import React from 'react';
import LayoutContainer from '../components/LayoutWrapper';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

const FAQs = () => {
    const { address, email } = useSelector(state => state.shop)

    return (
        <LayoutContainer>
            <h2>Frequently Asked Questions (FAQs)</h2>
            <p><strong>Q: What is the checkout process like?</strong></p>
            <p>
                A: The checkout process is designed to be straightforward and secure. Once you've added items to your cart, click the cart icon to review your selections. Then proceed to checkout, where you'll enter your shipping details, choose a delivery method, and select a payment option. Make sure to double-check all your information before placing the order.
            </p>

            <p><strong>Q: How do I enter my details during checkout?</strong></p>
            <p>
                A: You'll be asked to provide your shipping and billing addresses, as well as contact information. Please ensure everything is accurate to avoid any issues with delivery. All personal information is protected using secure encryption methods.
            </p>

            <p><strong>Q: What payment methods are accepted?</strong></p>
            <p>
                A: Multiple secure payment methods are supported, including major credit cards and trusted third-party processors. This helps ensure that your transaction is completed safely and conveniently.
            </p>

            <p><strong>Q: Can I modify or cancel an order after placing it?</strong></p>
            <p>
                A: If you need to make changes or cancel your order, please contact customer support as soon as possible. While modifications can't be guaranteed after confirmation, every effort will be made to accommodate your request if the order hasn’t been processed for shipment.
            </p>

            <p><strong>Q: How can I track my order?</strong></p>
            <p>
                A: Once your order has been shipped, you’ll receive a confirmation email with a tracking number and a link to the carrier’s tracking page. Use this to follow the progress of your delivery in real-time.
            </p>

            <p><strong>Q: What is the return policy?</strong></p>
            <p>
                A: If you're not fully satisfied with your order, a return can be initiated within a specified period. Items must be in original condition and packaging. Please refer to the return policy page for complete instructions and eligibility details.
            </p>

            <p><strong>Q: Is international shipping available?</strong></p>
            <p>
                A: Yes, international shipping is offered. Shipping fees are calculated based on destination and package weight. Estimated costs will be shown during checkout. Please note that customs duties or import taxes may apply depending on your location.
            </p>

            <p><strong>Q: How can I contact customer support?</strong></p>
            <p>
                A: For any inquiries, you can reach out through the contact page or email. Support teams typically respond within 24 hours. A live chat option may also be available during business hours for faster assistance.
            </p>

            <p><strong>Q: What should I do if I receive a damaged item?</strong></p>
            <p>
                A: If an item arrives damaged, please contact support immediately with your order details and photos of the issue. The team will review the case and offer a resolution, such as a refund or replacement. Customer satisfaction is a top priority.
            </p>
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </LayoutContainer>
    );
};

export default FAQs;
